<template>
  <div>
    <div
      v-if="serviceType === 'phone'"
      class="c-searchHeaderBanner"
    >
      <div class="c-searchHeaderBanner_inner-pc">
        <a
          :href="$coconala.registrationURL()"
          v-if="!this.isLoggedIn && displayPhoneFortuneTellingBannerCategory"
        >
          <img
            src="@/assets/images/common/banner/nologin_phone_fortune_telling_pc.png"
            alt="無料会員登録で最大30分間の無料相談ができる3,000円分クーポンをプレゼント"
          />
        </a>
        <a
          :href="searchHeaderBannerTo()"
          v-else
        >
          <img
            src="@/assets/images/common/banner/coconala_coin_pc.png"
            alt="ココナラコインの購入はこちら"
          />
        </a>
      </div>
      <div class="c-searchHeaderBanner_inner-sp">
        <a
          :href="$coconala.registrationURL()"
          v-if="!this.isLoggedIn && displayPhoneFortuneTellingBannerCategory"
        >
          <img
            src="@/assets/images/common/banner/nologin_phone_fortune_telling_sp.png"
            alt="無料会員登録で最大30分間の無料相談ができる3,000円分クーポンをプレゼント"
          />
        </a>
        <a
          :href="searchHeaderBannerTo()"
          v-else
        >
          <img
            src="@/assets/images/common/banner/coconala_coin_sp.png"
            alt="ココナラコインの購入はこちら"
          />
        </a>
      </div>
    </div>
    <div v-else>
      <div
        v-if="displayPhoneBannerCategory"
        class="c-searchHeaderBanner c-searchHeaderBanner-pc"
      >
        <a
          :href="`/categories/${categoryId}?service_kind=1`"
          class="c-phoneBanner"
        >
          <div class="c-phoneBannerInner">
            <div class="c-phoneBannerInner_left">
              <div class="c-phoneBannerInner_phone">
                <CoconalaIcon
                  class="c-phoneBannerInner_phoneIcon"
                  name="phone"
                />
              </div>
            </div>
            <div class="c-phoneBannerInner_center">
              <div class="c-phoneBannerInner_description c-phoneBannerDescription">
                <div class="c-phoneBannerDescription_caption"><span class="c-phoneBannerDescription_strong">1分100円〜</span>リーズナブルな価格で出品者に<span class="c-phoneBannerDescription_strong">電話相談</span></div>
                <div class="c-phoneBannerDescription_text">電話番号を知られずに通話ができるので、プライベート利用でも安心なのが特徴です。深夜でも携帯からすぐ電話相談できます。</div>
              </div>
            </div>
            <div class="c-phoneBannerInner_right">
              <div class="c-phoneBannerInner_more">
                一覧を見る
                <CoconalaIcon
                  class="c-phoneBannerInner_chevronRight"
                  name="chevron-right"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

const DISPLAY_PHONE_BANNER_CATEGORY = [2, 3]
const PHONE_FORTUNE_TELLING_BANNER_CATEGORY = 3

export default {
  name: 'ServiceSearchHeaderBanner',
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    parentCategoryId: {
      type: Number,
      default: null
    },
    serviceType: {
      type: String,
      default: 'text'
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('ui', ['isSP']),
    displayPhoneBannerCategory() {
      return DISPLAY_PHONE_BANNER_CATEGORY.some(c => c === this.parentCategoryId)
    },
    displayPhoneFortuneTellingBannerCategory() {
      return PHONE_FORTUNE_TELLING_BANNER_CATEGORY === this.parentCategoryId
    }
  },
  methods: {
    searchHeaderBannerTo() {
      if (this.$route.query.is_business) {
        return '/business/continue'
      }
      if (this.isSP) {
        return this.$coconala.url('/smartphone/points?ref=phone_service')
      }
      return this.$coconala.url('/points?ref=search_phone_category')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-searchHeaderBanner {
  margin: 8px 0 16px;

  &_inner {
    &-sp {
      display: none;
    }

    &-pc {
      display: block;
    }
  }
}

.c-phoneBanner {
  @include link-effect;

  display: block;
  min-height: 58px;
  border: 1px solid $color-gray-200;
  border-radius: 3px;
  background: $color-white;
  color: $color-gray-900;
}

.c-phoneBannerInner {
  display: flex;

  &_left {
    display: flex;
    flex: 0 0 56px;
    min-height: 58px;

    align-items: center;
    justify-content: center;
  }

  &_center {
    display: flex;
    padding: 6px 0;
    min-height: 46px;

    align-items: center;
    flex-grow: 1;
  }

  &_right {
    display: flex;
    flex: 0 0 105px;
    min-height: 58px;
    border-left: 1px solid $color-gray-200;

    align-items: center;
    justify-content: center;
  }

  &_phone {
    margin-top: 4px;
  }

  &_phoneIcon {
    color: $color-orange-500;
    font-size: 22px;
  }

  &_more {
    font-size: 12px;
  }

  &_chevronRight {
    margin-left: 4px;
    color: $color-gray-600;
    font-size: 10px;
  }
}

.c-phoneBannerDescription {
  &_caption {
    margin-bottom: 2px;
    color: $color-orange-500;
    font-size: 16px;
  }

  &_strong {
    font-weight: bold;
  }

  &_text {
    font-size: 12px;
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-searchHeaderBanner {
    margin: 12px;

    &_inner {
      text-align: center;
    }
  }
}

@media (max-width: breakpoint(Search, S)) {
  .c-searchHeaderBanner {
    margin: 12px;

    &-pc {
      display: none;
    }

    &_inner {
      &-sp {
        display: block;
      }

      &-pc {
        display: none;
      }
    }
  }
}
</style>
